export default __webpack_public_path__ + "assets/front/scss/common.f7ef0664dc6eaa4865b0797af8d12d03.css";